import React from 'react';
import { View, Text } from 'react-native';
import { dollars, numberWithDelimiter } from 'app/src/utils/stringHelpers';

import {
  CurrentBidDetailsContainer,
  CurrentBidValue,
} from '../elements';

const CurrentBidDetails = ({highBidDetails}) => {
  let bidOwner = highBidDetails?.buyer ||
    highBidDetails?.paddleService || 'Floor'
  ;

  function formatBidOwner() {
    if(!highBidDetails) return null;

    return (
      <View>
        <Text
          style={{
            color: highBidDetails?.foregroundColor ?
              highBidDetails?.foregroundColor : '#000',
            alignSelf: 'center',
            fontSize: '16px',
            paddingTop: '0px',
            fontWeight: 'bold'
          }}
        >
          {
            `${bidOwner === 'Floor' ? bidOwner : bidOwner.name || ''}`
          }
          </Text>
        <Text
          style={{
            color: highBidDetails?.foregroundColor ?
              highBidDetails?.foregroundColor : '#000',
            alignSelf: 'center',
            fontSize: '16px',
            fontWeight: 'bold',
            paddingBottom: '0px',
            minHeight: '20px'
          }}
        >
          {
            `${highBidDetails?.paddleNumber ? 'Paddle: ' + highBidDetails.paddleNumber : ''}`
          }
        </Text>
      </View>
    )
  }

  return (
    <CurrentBidDetailsContainer>
      <View>
        <Text
          style={{
            color: highBidDetails?.foregroundColor ?
              highBidDetails?.foregroundColor: '#000',
            alignSelf: 'center'
          }}
        >
          Current Bid:
        </Text>
      </View>
      <CurrentBidValue
        fontSize={!!highBidDetails ? '32px' : '20px'}
        color={highBidDetails?.foregroundColor ?
          highBidDetails?.foregroundColor: '#000'}
      >
        {!!highBidDetails ?
          `${dollars(highBidDetails.price)}` :
          'No Current Bid'
        }
      </CurrentBidValue>
      {formatBidOwner()}
    </CurrentBidDetailsContainer>
  )
}

export default CurrentBidDetails;